"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The PaymentAuthorization model module.
 * @module model/PaymentAuthorization
 * @version 3.0
 */
var PaymentAuthorization = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>PaymentAuthorization</code>.
   * @alias module:model/PaymentAuthorization
   */
  function PaymentAuthorization() {
    _classCallCheck(this, PaymentAuthorization);
    PaymentAuthorization.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(PaymentAuthorization, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>PaymentAuthorization</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaymentAuthorization} obj Optional instance to populate.
     * @return {module:model/PaymentAuthorization} The populated <code>PaymentAuthorization</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new PaymentAuthorization();
        if (data.hasOwnProperty('authorizationId')) {
          obj['authorizationId'] = _ApiClient["default"].convertToType(data['authorizationId'], 'Number');
        }
        if (data.hasOwnProperty('authorizationLegacyId')) {
          obj['authorizationLegacyId'] = _ApiClient["default"].convertToType(data['authorizationLegacyId'], 'String');
        }
        if (data.hasOwnProperty('approved')) {
          obj['approved'] = _ApiClient["default"].convertToType(data['approved'], 'Boolean');
        }
        if (data.hasOwnProperty('customerId')) {
          obj['customerId'] = _ApiClient["default"].convertToType(data['customerId'], 'Number');
        }
        if (data.hasOwnProperty('orderId')) {
          obj['orderId'] = _ApiClient["default"].convertToType(data['orderId'], 'Number');
        }
        if (data.hasOwnProperty('orderRefId')) {
          obj['orderRefId'] = _ApiClient["default"].convertToType(data['orderRefId'], 'String');
        }
        if (data.hasOwnProperty('receiptNo')) {
          obj['receiptNo'] = _ApiClient["default"].convertToType(data['receiptNo'], 'String');
        }
        if (data.hasOwnProperty('transactionNo')) {
          obj['transactionNo'] = _ApiClient["default"].convertToType(data['transactionNo'], 'String');
        }
        if (data.hasOwnProperty('gateway')) {
          obj['gateway'] = _ApiClient["default"].convertToType(data['gateway'], 'String');
        }
        if (data.hasOwnProperty('operator')) {
          obj['operator'] = _ApiClient["default"].convertToType(data['operator'], 'String');
        }
        if (data.hasOwnProperty('processDate')) {
          obj['processDate'] = _ApiClient["default"].convertToType(data['processDate'], 'Date');
        }
        if (data.hasOwnProperty('authorizationCode')) {
          obj['authorizationCode'] = _ApiClient["default"].convertToType(data['authorizationCode'], 'String');
        }
        if (data.hasOwnProperty('card')) {
          obj['card'] = _ApiClient["default"].convertToType(data['card'], 'Boolean');
        }
        if (data.hasOwnProperty('cardType')) {
          obj['cardType'] = _ApiClient["default"].convertToType(data['cardType'], 'String');
        }
        if (data.hasOwnProperty('paymentType')) {
          obj['paymentType'] = _ApiClient["default"].convertToType(data['paymentType'], 'String');
        }
        if (data.hasOwnProperty('amountApproved')) {
          obj['amountApproved'] = _ApiClient["default"].convertToType(data['amountApproved'], 'Number');
        }
        if (data.hasOwnProperty('amountLimit')) {
          obj['amountLimit'] = _ApiClient["default"].convertToType(data['amountLimit'], 'Number');
        }
        if (data.hasOwnProperty('amountUnits')) {
          obj['amountUnits'] = _ApiClient["default"].convertToType(data['amountUnits'], 'String');
        }
        if (data.hasOwnProperty('amountCurrency')) {
          obj['amountCurrency'] = _ApiClient["default"].convertToType(data['amountCurrency'], 'String');
        }
        if (data.hasOwnProperty('message')) {
          obj['message'] = _ApiClient["default"].convertToType(data['message'], 'String');
        }
        if (data.hasOwnProperty('messageCode')) {
          obj['messageCode'] = _ApiClient["default"].convertToType(data['messageCode'], 'String');
        }
        if (data.hasOwnProperty('date')) {
          obj['date'] = _ApiClient["default"].convertToType(data['date'], 'Date');
        }
        if (data.hasOwnProperty('basketRefId')) {
          obj['basketRefId'] = _ApiClient["default"].convertToType(data['basketRefId'], 'String');
        }
        if (data.hasOwnProperty('token')) {
          obj['token'] = _ApiClient["default"].convertToType(data['token'], 'String');
        }
        if (data.hasOwnProperty('tokenDetails')) {
          obj['tokenDetails'] = _ApiClient["default"].convertToType(data['tokenDetails'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PaymentAuthorization</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PaymentAuthorization</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['authorizationLegacyId'] && !(typeof data['authorizationLegacyId'] === 'string' || data['authorizationLegacyId'] instanceof String)) {
        throw new Error("Expected the field `authorizationLegacyId` to be a primitive type in the JSON string but got " + data['authorizationLegacyId']);
      }
      // ensure the json data is a string
      if (data['orderRefId'] && !(typeof data['orderRefId'] === 'string' || data['orderRefId'] instanceof String)) {
        throw new Error("Expected the field `orderRefId` to be a primitive type in the JSON string but got " + data['orderRefId']);
      }
      // ensure the json data is a string
      if (data['receiptNo'] && !(typeof data['receiptNo'] === 'string' || data['receiptNo'] instanceof String)) {
        throw new Error("Expected the field `receiptNo` to be a primitive type in the JSON string but got " + data['receiptNo']);
      }
      // ensure the json data is a string
      if (data['transactionNo'] && !(typeof data['transactionNo'] === 'string' || data['transactionNo'] instanceof String)) {
        throw new Error("Expected the field `transactionNo` to be a primitive type in the JSON string but got " + data['transactionNo']);
      }
      // ensure the json data is a string
      if (data['gateway'] && !(typeof data['gateway'] === 'string' || data['gateway'] instanceof String)) {
        throw new Error("Expected the field `gateway` to be a primitive type in the JSON string but got " + data['gateway']);
      }
      // ensure the json data is a string
      if (data['operator'] && !(typeof data['operator'] === 'string' || data['operator'] instanceof String)) {
        throw new Error("Expected the field `operator` to be a primitive type in the JSON string but got " + data['operator']);
      }
      // ensure the json data is a string
      if (data['authorizationCode'] && !(typeof data['authorizationCode'] === 'string' || data['authorizationCode'] instanceof String)) {
        throw new Error("Expected the field `authorizationCode` to be a primitive type in the JSON string but got " + data['authorizationCode']);
      }
      // ensure the json data is a string
      if (data['cardType'] && !(typeof data['cardType'] === 'string' || data['cardType'] instanceof String)) {
        throw new Error("Expected the field `cardType` to be a primitive type in the JSON string but got " + data['cardType']);
      }
      // ensure the json data is a string
      if (data['paymentType'] && !(typeof data['paymentType'] === 'string' || data['paymentType'] instanceof String)) {
        throw new Error("Expected the field `paymentType` to be a primitive type in the JSON string but got " + data['paymentType']);
      }
      // ensure the json data is a string
      if (data['amountUnits'] && !(typeof data['amountUnits'] === 'string' || data['amountUnits'] instanceof String)) {
        throw new Error("Expected the field `amountUnits` to be a primitive type in the JSON string but got " + data['amountUnits']);
      }
      // ensure the json data is a string
      if (data['amountCurrency'] && !(typeof data['amountCurrency'] === 'string' || data['amountCurrency'] instanceof String)) {
        throw new Error("Expected the field `amountCurrency` to be a primitive type in the JSON string but got " + data['amountCurrency']);
      }
      // ensure the json data is a string
      if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
        throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
      }
      // ensure the json data is a string
      if (data['messageCode'] && !(typeof data['messageCode'] === 'string' || data['messageCode'] instanceof String)) {
        throw new Error("Expected the field `messageCode` to be a primitive type in the JSON string but got " + data['messageCode']);
      }
      // ensure the json data is a string
      if (data['basketRefId'] && !(typeof data['basketRefId'] === 'string' || data['basketRefId'] instanceof String)) {
        throw new Error("Expected the field `basketRefId` to be a primitive type in the JSON string but got " + data['basketRefId']);
      }
      // ensure the json data is a string
      if (data['token'] && !(typeof data['token'] === 'string' || data['token'] instanceof String)) {
        throw new Error("Expected the field `token` to be a primitive type in the JSON string but got " + data['token']);
      }
      // ensure the json data is a string
      if (data['tokenDetails'] && !(typeof data['tokenDetails'] === 'string' || data['tokenDetails'] instanceof String)) {
        throw new Error("Expected the field `tokenDetails` to be a primitive type in the JSON string but got " + data['tokenDetails']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} authorizationId
 */
PaymentAuthorization.prototype['authorizationId'] = undefined;

/**
 * @member {String} authorizationLegacyId
 */
PaymentAuthorization.prototype['authorizationLegacyId'] = undefined;

/**
 * @member {Boolean} approved
 */
PaymentAuthorization.prototype['approved'] = undefined;

/**
 * @member {Number} customerId
 */
PaymentAuthorization.prototype['customerId'] = undefined;

/**
 * @member {Number} orderId
 */
PaymentAuthorization.prototype['orderId'] = undefined;

/**
 * @member {String} orderRefId
 */
PaymentAuthorization.prototype['orderRefId'] = undefined;

/**
 * @member {String} receiptNo
 */
PaymentAuthorization.prototype['receiptNo'] = undefined;

/**
 * @member {String} transactionNo
 */
PaymentAuthorization.prototype['transactionNo'] = undefined;

/**
 * @member {String} gateway
 */
PaymentAuthorization.prototype['gateway'] = undefined;

/**
 * @member {String} operator
 */
PaymentAuthorization.prototype['operator'] = undefined;

/**
 * @member {Date} processDate
 */
PaymentAuthorization.prototype['processDate'] = undefined;

/**
 * @member {String} authorizationCode
 */
PaymentAuthorization.prototype['authorizationCode'] = undefined;

/**
 * @member {Boolean} card
 */
PaymentAuthorization.prototype['card'] = undefined;

/**
 * @member {String} cardType
 */
PaymentAuthorization.prototype['cardType'] = undefined;

/**
 * @member {String} paymentType
 */
PaymentAuthorization.prototype['paymentType'] = undefined;

/**
 * @member {Number} amountApproved
 */
PaymentAuthorization.prototype['amountApproved'] = undefined;

/**
 * @member {Number} amountLimit
 */
PaymentAuthorization.prototype['amountLimit'] = undefined;

/**
 * @member {String} amountUnits
 */
PaymentAuthorization.prototype['amountUnits'] = undefined;

/**
 * @member {String} amountCurrency
 */
PaymentAuthorization.prototype['amountCurrency'] = undefined;

/**
 * @member {String} message
 */
PaymentAuthorization.prototype['message'] = undefined;

/**
 * @member {String} messageCode
 */
PaymentAuthorization.prototype['messageCode'] = undefined;

/**
 * @member {Date} date
 */
PaymentAuthorization.prototype['date'] = undefined;

/**
 * @member {String} basketRefId
 */
PaymentAuthorization.prototype['basketRefId'] = undefined;

/**
 * @member {String} token
 */
PaymentAuthorization.prototype['token'] = undefined;

/**
 * @member {String} tokenDetails
 */
PaymentAuthorization.prototype['tokenDetails'] = undefined;
var _default = exports["default"] = PaymentAuthorization;